import { toast } from "@inno-ui/toast";
import { useMutation } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router";

import type { SmartSchedulingSlotsPayload } from "../../api/smart-scheduling/smart-scheduling.types";

import { bookSmartSchedulingAvailability } from "../../api/smart-scheduling/book-smart-scheduling-availability";

export function useBookSmartSchedulingSlots() {
  const { t } = useTranslation();
  const { userToken } = useParams();

  if (!userToken) {
    toast.error({ title: t("User token is required") });
    return;
  }

  return useMutation({
    mutationFn: (payload: SmartSchedulingSlotsPayload) =>
      bookSmartSchedulingAvailability(userToken, payload),
    onError: (error) => {
      return error;
    },
  });
}
